@if (compact()) {
  <div
    class="border-standard-outline-light flex h-10 w-full overflow-hidden rounded-xl border-1"
    role="group"
    [attr.aria-label]="ariaLabel()">
    @for (option of options(); track option.value) {
      @let isActiveOption = ngControl.control!.value === option.value;
      <button
        type="button"
        class="border-standard-outline-light flex min-w-0 flex-1 items-center justify-center gap-2 border-r-1 transition-colors last:border-r-0"
        [attr.data-testid]="id() | appendTestId: option.label"
        [disabled]="ngControl.control!.disabled"
        [attr.aria-pressed]="isActiveOption"
        [ngClass]="{
          'bg-standard-selected font-semibold': isActiveOption,
          'hover:bg-standard-hover-main':
            !isActiveOption && !ngControl.control!.disabled,
          'cursor-pointer': !ngControl.control!.disabled,
          'bg-standard-disabled cursor-not-allowed':
            ngControl.control!.disabled,
        }"
        (click)="changeActive(option)">
        @if (isActiveOption) {
          @if (option.iconSrc) {
            <img class="size-5" [src]="option.iconSrc" alt="" />
          } @else {
            <span class="material-symbols-rounded h-6" aria-hidden="true"
              >check</span
            >
          }
        }
        <span>{{ option.label }}</span>
      </button>
    }
  </div>
} @else {
  @let showOnHoverStyling = hoveredMouseButton();
  @let corporateDesign = corporateDesignService.corporateDesign();
  <div
    class="flex w-full flex-wrap"
    role="group"
    [attr.aria-label]="ariaLabel()"
    #buttonGroup
    [ngClass]="{
      'cursor-not-allowed': ngControl.control!.disabled,
    }">
    @for (option of options(); track option; let index = $index) {
      @let isActiveOption = ngControl.control!.value === option.value;
      <button
        [attr.data-testid]="id() | appendTestId: option.label"
        type="button"
        [attr.aria-pressed]="isActiveOption"
        [value]="option"
        [disabled]="ngControl.control!.disabled"
        [ngClass]="{
          'bg-standard-disabled pointer-events-none':
            ngControl.control!.disabled,
          '!cursor-pointer': !ngControl.control!.disabled,
          'bg-[#282829] text-[#FFFFFF99] hover:bg-[#2F2F2F]':
            !isActiveOption && isDarkMode(),
          'bg-primary-dark text-standard-text-dark hover:bg-[#2F2F2F]':
            isActiveOption && isDarkMode(),
          'bg-standard-selected': isActiveOption && !isDarkMode(),
          'text-input-focus':
            isActiveOption &&
            !isDarkMode() &&
            siteContextService.isShopContext(),
          'text-standard-text-primary': !siteContextService.isShopContext(),
          'bg-primary-on hover:bg-standard-hover-main':
            !isActiveOption && !isDarkMode(),
          'hover:(text-black bg-info-light)': isDarkMode(),
        }"
        (mouseenter)="hoveredMouseButton.set(index)"
        (mouseleave)="hoveredMouseButton.set(undefined)"
        [ngStyle]="{
          color: ngControl.control!.disabled
            ? ''
            : showOnHoverStyling === index
              ? isDarkMode()
                ? ''
                : hoverFontColor()
              : isActiveOption
                ? corporateFontColor()
                : '',
          background: ngControl.control!.disabled
            ? ''
            : showOnHoverStyling === index
              ? isDarkMode()
                ? ''
                : hoverBackgroundColor()
              : isActiveOption
                ? corporateBackgroundColor()
                : isDarkMode()
                  ? corporateDesign.colorAdmixtures.dark_surface_04
                  : '',
          borderColor: ngControl.control!.disabled
            ? ''
            : showOnHoverStyling === index
              ? isDarkMode()
                ? ''
                : hoverBorderColor()
              : isActiveOption
                ? corporateBorderColor()
                : isDarkMode()
                  ? corporateDesign.colorAdmixtures.dark_surface_04
                  : '',
        }"
        (click)="changeActive(option)"
        class="border-standard-outline-light p-input box-border flex items-center justify-center gap-2 overflow-hidden rounded-lg border-r-1 border-b-1 px-0 whitespace-nowrap">
        <!-- important to set padding like this (p-[value] px-0), setting just py-[value] causes the button the be too large :( -->
        @if (isActiveOption) {
          @if (option.iconSrc) {
            <img class="size-5" [src]="option.iconSrc" alt="" />
          } @else {
            <span class="material-symbols-rounded h-6" aria-hidden="true">
              check
            </span>
          }
        }
        {{ option.label }}
      </button>
    }
  </div>
}
